import React from "react";
import firebase from "firebase.config";

class DashboardAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: true,
      ID: ""
    };
    console.warn("props data", props.data);
  }

  componentDidMount() { }

  // ----- Tailwind 공통 입력 스타일 -----
  inputCls =
    "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200";

  addId = async () => {
    if (this.state.ID.length < 2) {
      alert("Please enter a valid ID");
      return;
    }

    let idCheck = await firebase
      .database()
      .ref("groups/" + this.state.ID.toLowerCase())
      .once("value");
    if (idCheck.val()) {
      alert("The mentioned ID is already in use, please try some other ID");
      return;
    }

    let res = window.confirm(
      "Are you sure that you want to set group ID to " +
      this.state.ID +
      "? You wont be able to change it later on"
    );

    if (res) {
      firebase
        .database()
        .ref("/groupsData/")
        .push({
          owner: this.props.uid
        })
        .then(res => {
          firebase
            .database()
            .ref("/groups/")
            .update({
              [this.state.ID.toLowerCase()]: res.key
            });

          firebase
            .database()
            .ref("/admin/" + this.props.uid)
            .update({
              group: this.state.ID.toLowerCase(),
              groupPath: res.key
            });
        });
    }
  };

  handleChange = (event, key) => {
    this.setState({
      [key]: event.target.value
    });
  };

  renderStatCard(icon, label, value, color) {
    return (
      <div className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
        <div
          className={
            "flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl text-2xl " +
            color
          }
        >
          {icon}
        </div>
        <div>
          <p className="text-sm text-gray-500">{label}</p>
          <p className="text-2xl font-bold text-gray-800">{value}</p>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="content">
        <div className="mx-auto w-full max-w-4xl px-2 pb-10">
          {/* 안내 배너 */}
          <div className="mb-6 rounded-2xl bg-gradient-to-r from-sky-500 to-cyan-400 p-6 text-white shadow-lg">
            <h2 className="mb-1 text-2xl font-bold">📊 대시보드</h2>
            <p className="text-sm leading-relaxed text-sky-50">
              우리 그룹의 뉴스레터 발행 현황과 구독자 수를 한눈에 확인하세요.
            </p>
          </div>

          {/* 통계 카드 */}
          <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {this.renderStatCard(
              "📰",
              "발행한 뉴스레터",
              this.props.stats.newsletters ? this.props.stats.newsletters : 0,
              "bg-amber-100 text-amber-600"
            )}
            {this.renderStatCard(
              "👥",
              "구독자 수",
              this.props.stats.subs ? this.props.stats.subs : 0,
              "bg-emerald-100 text-emerald-600"
            )}
          </div>

          {/* 그룹 ID */}
          <section className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            {!this.props.userDetails.group ? (
              <>
                <div className="mb-1 flex items-center gap-2">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                    !
                  </span>
                  <h3 className="text-lg font-bold text-gray-800">
                    그룹 고유 ID 설정
                  </h3>
                </div>
                <p className="mb-4 ml-9 text-sm text-gray-500">
                  뉴스레터·이벤트를 만들려면 먼저 그룹의 고유 ID를 정해야 합니다.
                  <span className="font-semibold text-rose-500">
                    {" "}
                    한 번 설정하면 변경할 수 없으니
                  </span>{" "}
                  신중하게 입력하세요.
                </p>
                <div className="ml-0 flex flex-col gap-3 sm:ml-9 sm:flex-row">
                  <input
                    type="text"
                    placeholder="예) mission21news - 성도에게 알리기 쉬운 것으로 입력하세요."
                    className={this.inputCls + " sm:flex-1"}
                    onChange={event => this.handleChange(event, "ID")}
                  />
                  <button
                    type="button"
                    className="inline-flex items-center justify-center gap-1 rounded-xl bg-sky-500 px-6 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-sky-600"
                    onClick={() => this.addId()}
                  >
                    ID 설정하기
                  </button>
                </div>
              </>
            ) : (
              <div className="text-center">
                <p className="text-sm text-gray-600">
                  <b>{this.props.userDetails.name}</b>님, 현재 그룹 ID는{" "}
                  <span className="rounded-md bg-sky-50 px-2 py-1 font-bold text-sky-600">
                    {this.props.userDetails.group}
                  </span>{" "}
                  입니다.
                </p>
              </div>
            )}
          </section>
        </div>
      </div>
    );
  }
}

export default DashboardAdmin;
